import * as React from "react"
import { HTMLAttributeAnchorTarget, MouseEventHandler } from "react";

interface ILinkProps {
  href?: string
  target?: HTMLAttributeAnchorTarget
  external?: boolean
  rel?: string
  children?: React.ReactNode,
  onClick?: MouseEventHandler<HTMLAnchorElement>
}

// TODO: more use cases with target _blank - create something similar to getSecureRelForTarget (elastic ui)
// https://www.jitbit.com/alexblog/256-targetblank---the-most-underestimated-vulnerability-ever/
// TODO: external icon
export function Link({ href, target: targetProp, external, onClick, children }: ILinkProps): JSX.Element {
  let target = targetProp;
  let rel = "";

  if (external) {
    target = "_blank";
  }

  if (target == "_blank") {
    rel = "noreferrer";
  }

  return <a
    onClick={onClick}
    href={href}
    target={target}
    rel={rel}
  >
    {children}
  </a>;
}
